export default __webpack_public_path__ + "static/media/img13.0e79d9e5.jpg";